/*
 * @Author       : didi
 * @Date         : 2022/1/26 2:31 下午
 * @Description  : 
 */

import {mpx} from '@didi/es-mpx-creator'
import { GET_TRAIN_CITY_LIST, GET_TRAIN_CITY_LIST_BY_KEYWORD } from './urls';

export const getTrainCityList = () => {
  return mpx.$http.post(
    GET_TRAIN_CITY_LIST
  )
}

export const getTrainCityListByKeyword = (data) => {
  return mpx.$http.post(
    GET_TRAIN_CITY_LIST_BY_KEYWORD,
    { data }
  )
}
